var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_vm._m(0):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c(_vm.icon,{tag:"component",staticClass:"icon",class:{'no-fill': _vm.noFill}})
}]

export { render, staticRenderFns }